<template>
  <div class="card-autopilot-task">
    <div class="card-autopilot-task__loader" :class="{ active: loading }">
      <i class="far fa-spinner-third fa-spin" />
      <span v-if="loadingStatus">
        {{ loadingStatus }}
      </span>
    </div>
    <div class="card-autopilot-task__top">
      <!-- TODO: Make the badge change color based on status -->
      <div
        v-if="task.status"
        class="card-autopilot-task__status badge badge-pill badge-secondary"
        :class="badgeClasses[task.status]">
        {{ task.status }}
      </div>
      <div class="card-autopilot-task__type">
        <span>
          Type:
        </span>
        <span>
          {{ task.contentType }}
        </span>
      </div>
      <div v-if="task.processedAt" class="card-autopilot-task__date">{{ task.processedAt }}</div>
    </div>
    <div class="card-autopilot-task__content">
      <component
        :is="componentNamesMap[task.contentType]"
        :task="task"
        :can-regenerate="canRegenerate"
        :allow-actions="allowActions"
        @regenerate="regenerateTask"
        @update="editAndApproveTask" />
    </div>
    <div class="card-autopilot-task__actions">
      <template v-if="allowActions">
        <button
          class="btn btn-xs px-2 btn-primary rounded"
          @click="approveTask">
          <span>Approve</span>
        </button>
        <button
          class="btn btn-xs px-2 btn-danger rounded"
          @click="rejectTask">
          <span>Reject</span>
        </button>
      </template>
      <!-- TODO: Add handling when backend will be ready -->
      <template v-else-if="task.status === 'rejected' && false">
        <button class="btn btn-xs px-2 btn-primary rounded">
          <i class="fa-regular fa-arrow-up mr-2" />
          <span>Put back to "My Tasks"</span>
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import axiosTransform from 'common/axios'
import { DEFAULT_ERROR_MESSAGE } from 'common/constants'

import ContentReview from './ContentReview.vue'

export default {
  components: {
    ContentReview
  },
  props: {
    task: {
      type: Object,
      reqruied: true
    },
    locationId: {
      type: String,
      required: true
    },
    canRegenerate: {
      type: Boolean,
      required: false,
      default: false
    },
    preview: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      mutableTask: this.task,
      loading: false,
      loadingStatus: ''
    }
  },
  created() {
    this.componentNamesMap = {
      review: 'ContentReview'
    }

    this.badgeClasses = {
      draft: 'badge-secondary',
      rejected: 'badge-danger',
      approved: 'badge-success'
    }

    if (this.task.processing) {
      this.loading = true
      this.loadingStatus = 'Generating...'
    }
  },
  methods: {
    approveTask() {
      this.loading = true
      axios.post(`/api/organizations_locations/${this.locationId}/ai_autopilot/${this.task.id}/approve`, null, axiosTransform)
        .then((res) => {
          toastr.success('Task approved')
          this.$emit('updateTask', res.data)
        })
        .catch((err) => {
          const errorText = err?.response?.data?.text ?? DEFAULT_ERROR_MESSAGE
          toastr.error(errorText)
        })
        .finally(() => {
          this.loading = false
        })
    },
    rejectTask() {
      this.loading = true
      axios.post(`/api/organizations_locations/${this.locationId}/ai_autopilot/${this.task.id}/reject`, null, axiosTransform)
        .then((res) => {
          toastr.success('Task rejected')
          this.$emit('updateTask', res.data)
        })
        .finally(() => {
          this.loading = false
        })
    },
    regenerateTask() {
      this.loading = true
      this.loadingStatus = 'Generating...'

      axios.post(`/api/organizations_locations/${this.locationId}/ai_autopilot/${this.task.id}/generate`)
    },
    editAndApproveTask(text) {
      axios.post(`/api/organizations_locations/${this.locationId}/ai_autopilot/${this.task.id}/edit_draft`, {
        text
      }, axiosTransform)
        .then((res) => {
          toastr.success('Task approved')
          this.$emit('updateTask', res.data)
        })
        .catch((err) => {
          const errorText = err?.response?.data?.text ?? DEFAULT_ERROR_MESSAGE
          toastr.error(errorText)
        })
    }
  },
  watch: {
    task: {
      handler(newTaskData) {
        this.loading = newTaskData.processing

        if (this.loading) return

        this.loadingStatus = ''
      },
      deep: true
    }
  },
  computed: {
    allowActions() {
      return this.task.status === 'draft' && !this.preview
    }
  }
}
</script>
